<template>
  <section class="video-card">
    <div class="video-wrap">
      <span>{{ frame }}</span>
      <video
        ref="videoEl"
        controls
        :src="videoUrl"
        :controlslist="isVisualization ? 'nofullscreen' : ''"
        disablepictureinpicture
        playsinline
        @play="$emit('play')"
        @pause="$emit('pause')"
        @seeking="$emit('seeking', $event)"
        @ended="$emit('ended')"
        @loadeddata="$emit('ready', videoEl)"
      />
    </div>
  </section>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'VideoPanel',
  props: {
    videoUrl: { type: String, default: '' },
    // Used to optionally hide fullscreen control via controlslist
    isVisualization: { type: Boolean, default: false },
  },
  emits: ['ready', 'play', 'pause', 'seeking', 'ended'],
  setup() {
    const videoEl = ref(null);

    return { videoEl };
  },
};
</script>

<style scoped>
.video-card {
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
  background: #fff;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.video-wrap {
  position: relative;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
  height: 100%;
}

.video-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.placeholder {
  color: #d1d5db;
  font-size: var(--fs-md);
}
@media (max-width: 780px) {
  .video-wrap {
    height: 100%;
  }
}
</style>
